import VendSizeFlavorXref from './VendSizeFlavorXref'
import Employee from './Employee'
export class SaveVendSizeFlavorXrefRequest {
    VendSizeFlavorXref: VendSizeFlavorXref;
    SavedByEmployee: Employee;
}

export default SaveVendSizeFlavorXrefRequest;